<template>
  <div v-loading="isLoading">
    <div class="contract-viewer-summary">
      <i class="el-icon-warning"></i>
      <span>下列表格中是您尚未签署的占位/课程合同. 在&nbsp;"签署"&nbsp;列的方框中勾选即视为您同意此合同的全部内容.</span>
    </div>
    <el-table :data="contractList" style="width: 100%;"  class="contract-viewer-table" empty-text="暂无待签署的合同">
      <el-table-column prop="ContractTypeName" label="类型" width="80"></el-table-column>
      <el-table-column prop="Term" label="学期" width="100"></el-table-column>
      <el-table-column prop="CourseName" label="占位/课程" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.ContractType == 1">{{scope.row.AdvanceEnrollmentComment}}</span>
          <span v-else>{{scope.row.CourseName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ContractDescription" label="合同" width="120"></el-table-column>
      <el-table-column label="合同文本" width="100">
        <template slot-scope="scope">
          <ul>
            <li v-for="(item, index) in scope.row.FilePaths" :key="item">
              <el-button type="text" @click="onClickDownloadContract(item)">
                查看合同
                <span v-if="scope.row.FilePaths.length > 1">{{index + 1}}</span>
              </el-button>
            </li>
          </ul>
        </template>
      </el-table-column>
      <el-table-column label="签署">
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.IsAccepted"> 我同意此合同的全部内容</el-checkbox>
        </template>
      </el-table-column>
    </el-table>
    <div class="contract-viewer-footer">
      <el-button type="primary" size="medium" :disabled="!submitButtonEnabled" :loading="submitInProgress" v-on:click="commit">提交</el-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>

  .contract-viewer-table{

    ul {
      list-style-type: none;
      padding-left: 3px;
      margin-bottom: 0;
    }

    .el-checkbox{
      margin-bottom: 0;
    }
  }

  .contract-viewer-footer {
    text-align: center;
    margin-top: 20px;
  }


</style>

<script>
import {
  openLink
} from "@/config/mUtils";
import {
  getUncheckedStudentContracts,
  signContracts
} from "@/service/contract.service";

export default {
  data() {
    return {
      contractList: [],
      submitInProgress: false,
      isLoading: false
    };
  },
  props: {
    courses: {
      type: Array,
      default: () => [],
    },
  },
  updated() {},
  created() {
    this.isLoading = true;
    getUncheckedStudentContracts(this.courses).then((rs) => {

      if(rs != null && rs.success && rs.data.length > 0) {
        this.contractList = rs.data;
      }else{
        this.contractList = [];
      }

      this.isLoading = false;

      if (this.contractList.length == 0){
        this.$emit("contractSigned");
      }

    });
  },
  methods: {
    async commit() {
      let unacceptedItems =  this.contractList.filter((i) => !i.IsAccepted);
      let acceptedItems =  this.contractList.filter((i) => i.IsAccepted);
      let workflowIds = acceptedItems.filter(i => i.ContractType == 1).map(i => i.WorkflowIds).flat();
      let workflowCourseIds = acceptedItems.filter(i => i.ContractType != 1).map(i => i.WorkflowCourseId);
      let courseIds = acceptedItems.filter(i => i.ContractType != 1).map(i => i.CourseId);

      if(unacceptedItems.length > 0) {
        let advanceEnrollmentComments = unacceptedItems.filter(i => i.ContractType == 1).map(i => i.AdvanceEnrollmentComment);
        let courseNames = unacceptedItems.filter(i => i.ContractType != 1).map(i => i.CourseName);
        let desc = "";
        if (advanceEnrollmentComments.length > 0){
          desc += "占位(" + advanceEnrollmentComments.join(",") + ")";
        }
        if (courseNames.length > 0){
          if (desc){
            desc += ", ";
          }
          desc += "课程(" + courseNames.join(",") + ")";
        }
        this.$message.warning(`您没有签署${desc}对应合同, 请您仔细阅读合同后勾选再提交.`);
        return;
      }

      try
      {
        this.submitInProgress = true;
    
        let result = await signContracts(workflowIds, workflowCourseIds);
        if (!result.success){
          this.$message.error(result.message);
          return;
        }
        this.$message.success("合同签署成功.");

        this.$emit("contractSigned", courseIds);
      }
      finally{
        this.submitInProgress = false;
      }
    },
    onClickDownloadContract(link){
      openLink(link);
    }
  },
  computed: {
    submitButtonEnabled: function () {
      return (this.contractList && this.contractList.filter((v, i, a) => v.IsAccepted).length > 0) && !this.submitInProgress;
    }
  },
  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/components/contractViewer.vue